// ═══════════════════════════════════════════════════════════════════
//  modules/sanctions/api.js
//  Un seul endroit qui parle au backend du module Sanctions.
// ═══════════════════════════════════════════════════════════════════

import { API_BASE } from "../../socle/api";

export function sanctionsApi(token) {
  const h = { Authorization: `Bearer ${token}` };
  const hj = { ...h, "Content-Type": "application/json" };

  const lire = async (chemin) => {
    const r = await fetch(`${API_BASE}${chemin}`, { headers: h });
    const d = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(d.error || `Erreur ${r.status}`);
    return d;
  };
  const ecrire = async (chemin, corps, methode) => {
    const r = await fetch(`${API_BASE}${chemin}`, {
      method: methode || "POST", headers: hj,
      body: corps === undefined ? undefined : JSON.stringify(corps),
    });
    const d = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(d.error || `Erreur ${r.status}`);
    return d;
  };

  const qs = (filtres) => {
    const p = new URLSearchParams();
    Object.entries(filtres || {}).forEach(([k, v]) => { if (v !== "" && v != null) p.set(k, v); });
    return p.toString();
  };

  return {
    bareme: () => lire("/api/sanctions/bareme"),
    liste: (filtres) => lire(`/api/sanctions?${qs(filtres)}`),
    stats: () => lire("/api/sanctions/stats"),
    fiche: (id) => lire(`/api/sanctions/${id}`),
    joueur: (pseudo) => lire(`/api/sanctions/joueur/${encodeURIComponent(pseudo)}`),
    commenter: (id, contenu) => ecrire(`/api/sanctions/${id}/journal`, { contenu }),
    modifier: (id, champs) => ecrire(`/api/sanctions/${id}`, champs, "PATCH"),
    lever: (id, motif) => ecrire(`/api/sanctions/${id}/lever`, { motif }),
    duree: (id, dureeMin, motif) => ecrire(`/api/sanctions/${id}/duree`, { duree_min: dureeMin, motif }),

    dossiers: (statut) => lire(`/api/sanctions/dossiers/liste${statut ? `?statut=${statut}` : ""}`),
    dossier: (id) => lire(`/api/sanctions/dossiers/${id}`),
    dossierListeBlanche: (id) => ecrire(`/api/sanctions/dossiers/${id}/liste-blanche`),
    dossierBannir: (id, note) => ecrire(`/api/sanctions/dossiers/${id}/bannir`, { note }),

    comptesLies: () => lire("/api/sanctions/comptes-lies/liste"),
    lierComptes: (a, b, motif) => ecrire("/api/sanctions/comptes-lies", { pseudo_a: a, pseudo_b: b, motif }),
    delierComptes: (id) => ecrire(`/api/sanctions/comptes-lies/${id}`, undefined, "DELETE"),

    auditBlanc: () => lire("/api/sanctions/audit-blanc"),
  };
}
